/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AllergenPropertyKind =
  | 'CRUSTACEAN_SHELLFISH'
  | 'EGGS'
  | 'FISH'
  | 'MEAT'
  | 'MILK'
  | 'PEANUTS'
  | 'SESAME'
  | 'SOYBEANS'
  | 'TREE_NUTS'
  | 'WHEAT';

export type ConflictType =
  | 'DELIVERY_INELIGIBLE'
  | 'INGREDIENT_UNAVAILABLE'
  | 'NO_CONFLICT'
  | 'PRODUCT_UNAVAILABLE';

export type DietaryPropertyKind = 'DAIRY' | 'FISH' | 'GLUTEN' | 'MEAT' | 'NUTS' | 'SOY';

export type DressingMode = 'MIXED' | 'NOT_DRESSABLE' | 'ON_THE_SIDE' | 'REMOVED';

export type DressingWeight = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type IngredientKind = 'BASE' | 'DRESSING' | 'PREMIUM' | 'TOPPING';

export type ModifierType = 'ADDITION' | 'INCLUDED' | 'MIXED_DRESSING' | 'REMOVAL' | 'SUBSTITUTION';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type HasActiveBagQueryVariables = Exact<{ [key: string]: never }>;

export type HasActiveBagQuery = {
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly lineItems: ReadonlyArray<{ readonly __typename: 'LineItem'; readonly id: string }>;
  } | null;
};

export type CartHandoffMutationVariables = Exact<{
  orderToken: string;
  ignoreConflicts: boolean;
}>;

export type CartHandoffMutation = {
  readonly handoffCart:
    | { readonly __typename: 'CanNotReorder'; readonly message: string }
    | {
        readonly __typename: 'ReorderConflict';
        readonly isNothingAvailable: boolean;
        readonly conflicts: ReadonlyArray<{
          readonly type: Types.ConflictType;
          readonly product: {
            readonly __typename: 'Product';
            readonly id: string;
            readonly name: string;
            readonly calories: number;
            readonly cost: number;
            readonly description: string;
            readonly label: {
              readonly __typename: 'ProductLabel';
              readonly id: string;
              readonly name: string;
            } | null;
            readonly asset: { readonly url: string };
            readonly allergenProperties: ReadonlyArray<{
              readonly __typename: 'AllergenProperty';
              readonly id: string;
              readonly name: Types.AllergenPropertyKind;
            }>;
            readonly dietaryProperties: ReadonlyArray<{
              readonly __typename: 'DietaryProperty';
              readonly id: string;
              readonly name: Types.DietaryPropertyKind;
            }>;
          };
          readonly unavailableIngredients: ReadonlyArray<{
            readonly __typename: 'Ingredient';
            readonly id: string;
            readonly name: string;
          }>;
        }>;
      }
    | {
        readonly __typename: 'ReorderSuccess';
        readonly isMixingSupported: boolean;
        readonly cart: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly ledger: {
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly categoryName: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly enableDressingDetails: boolean;
              readonly isModifiable: boolean;
              readonly calories: number;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly url: string };
          };
        };
      }
    | { readonly __typename: 'RestaurantMaxDeliveryQuantityExceeded'; readonly message: string }
    | { readonly __typename: 'RestaurantMaxQuantityExceeded'; readonly message: string }
    | { readonly __typename: 'UnauthorizedOrderModification' }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const HasActiveBagDocument = gql`
  query HasActiveBag {
    cart {
      id
      __typename
      lineItems {
        id
        __typename
      }
    }
  }
`;

export function useHasActiveBagQuery(
  options?: Omit<Urql.UseQueryArgs<HasActiveBagQueryVariables>, 'query'>,
) {
  return Urql.useQuery<HasActiveBagQuery, HasActiveBagQueryVariables>({
    query: HasActiveBagDocument,
    ...options,
  });
}
export const CartHandoffDocument = gql`
  mutation CartHandoff($orderToken: String!, $ignoreConflicts: Boolean!) {
    handoffCart(orderToken: $orderToken, ignoreConflicts: $ignoreConflicts) {
      __typename
      ... on ReorderSuccess {
        isMixingSupported
        cart {
          id
          __typename
          orderType
          ledger {
            tax
            subtotal
            feesTotal
            discountsTotal
            creditsTotal
            tip
            discounts {
              id
              __typename
              name
              amount
              description
            }
            credits {
              id
              __typename
              name
              amount
              description
            }
            fees {
              id
              __typename
              name
              amount
              description
            }
          }
          lineItems {
            id
            __typename
            slug
            quantity
            cost
            customName
            perItemCost
            favorited
            isCustom
            addedIngredients {
              id
              __typename
              name
              kind
              asset {
                url
              }
            }
            removedIngredients {
              id
              __typename
              name
              kind
              asset {
                url
              }
            }
            product {
              id
              __typename
              name
              categoryName
              slug
              isCustom
              enableDressingDetails
              isModifiable
              calories
              asset {
                url
              }
              ingredients {
                id
                __typename
                name
                kind
              }
            }
            mixedDressingDetails {
              ingredientId
              weight
            }
            dressingMode
            selectedModifiers {
              id
              modifierType
              cost
              parentId
              ingredient {
                id
                name
                kind
              }
            }
          }
          restaurant {
            id
            __typename
            slug
            name
            city
            state
            address
            zipCode
            isOutpost
            availableDropOffLocations {
              id
              __typename
              name
            }
            asset {
              url
            }
          }
        }
      }
      ... on ReorderConflict {
        isNothingAvailable
        conflicts {
          type
          product {
            id
            __typename
            name
            calories
            cost
            label {
              id
              __typename
              name
            }
            description
            asset {
              url
            }
            allergenProperties {
              id
              __typename
              name
            }
            dietaryProperties {
              id
              __typename
              name
            }
          }
          unavailableIngredients {
            id
            __typename
            name
          }
        }
      }
      ... on RestaurantMaxDeliveryQuantityExceeded {
        message
      }
      ... on RestaurantMaxQuantityExceeded {
        message
      }
      ... on CanNotReorder {
        message
      }
      ... on ValidationError {
        message
        status
        fieldErrors {
          field
          message
        }
      }
    }
  }
`;

export function useCartHandoffMutation() {
  return Urql.useMutation<CartHandoffMutation, CartHandoffMutationVariables>(CartHandoffDocument);
}
